import { render, staticRenderFns } from "./RegisterAdmin.vue?vue&type=template&id=757f4c71&scoped=true&"
import script from "./RegisterAdmin.vue?vue&type=script&lang=js&"
export * from "./RegisterAdmin.vue?vue&type=script&lang=js&"
import style0 from "./RegisterAdmin.vue?vue&type=style&index=0&id=757f4c71&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "757f4c71",
  null
  
)

export default component.exports